import {
  auth,
  // functions,
  db,
} from '@/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  where,
} from 'firebase/firestore';
import store from '@/store';
import { Subscription } from '@stripe/firestore-stripe-payments';

// import strings from '@/constants/strings';
import {
  // Keyword,
  // Sprint,
  // Document,
  UserData,
  Location,
} from '@/constants/types';

// eslint-disable-next-line no-async-promise-executor
export const setUserData = (res: any) => new Promise(async (resolve, reject) => {
  try {
    const { uid } = res;
    const { claims } = await res.getIdTokenResult();
    await store.dispatch('updateCurrentUser', res); // updateCurrentCustomer
    const docRef = doc(db, 'users', uid);
    const user = await getDoc(docRef);

    if (user.exists()) {
      const token = await auth.currentUser?.getIdToken(true);
      localStorage.setItem('jwt', token || '');

      const data: UserData = {
        ...user.data() as UserData,
        role: claims.role,
        admin: claims.admin,
      };

      // if (auth.currentUser) {
      //   data.emailVerified = auth.currentUser.emailVerified;
      // }

      const snapshots = store.state.unsubscribe;

      const q = query(
        collection(db, 'users', user.id, 'subscriptions'),
        where('status', 'in', ['active', 'trialing']),
      );

      const querySnapshot = await getDocs(q);

      const subscriptions = [] as Subscription[];
      querySnapshot.forEach((subscription: any) => {
        subscriptions.push(subscription.data());
        store.dispatch('updateCurrentPlan', subscription.data());
        snapshots.push(subscription);
      });

      store.dispatch('updateUserData', { ...data, id: user.id, ref: user.ref });
      snapshots.push(user);

      const locations = [] as Location[];
      const locationsCollection = collection(db, 'locations');
      const locationsSnapshot = await getDocs(query(locationsCollection, where(`users.${user.id}`, '!=', null)));
      locationsSnapshot.forEach((location) => {
        locations.push({ id: location.id, ...location.data() } as Location);
        snapshots.push(location);
        if (location.id === data.primaryLocation) {
          store.dispatch('updateCurrentLocation', { id: location.id, ...location.data() } as Location);
        }
      });

      // const keywords = [] as Keyword[];
      // const keywordsCollection = collection(db, 'locations', data.primaryLocation, 'keywords');
      // const keywordsSnapshot = await getDocs(keywordsCollection);
      // keywordsSnapshot.forEach((keyword) => {
      //   keywords.push({ id: keyword.id, ...keyword.data() } as Keyword);
      //   snapshots.push(keyword);
      // });
      // store.dispatch('updateKeywords', keywords);

      // const sprints = [] as Sprint[];
      // const sprintsCollection = collection(db, 'locations', data.primaryLocation, 'sprints');
      // const sprintsSnapshot = await getDocs(sprintsCollection);
      // sprintsSnapshot.forEach((sprint) => {
      //   sprints.push({ id: sprint.id, ...sprint.data() } as Sprint);
      //   snapshots.push(sprint);
      // });
      // store.dispatch('updateSprints', sprints);

      // const documents = [] as Document[];
      // const documentsCollection = collection(db, 'locations', data.primaryLocation, 'content');
      // const documentsSnapshot = await getDocs(documentsCollection);
      // documentsSnapshot.forEach((document) => {
      //   documents.push({ id: document.id, ...document.data() } as Document);
      //   snapshots.push(document);
      // });
      // store.dispatch('updateDocuments', documents);

      store.dispatch('updateLocations', locations);
      store.commit('setUnsubscribe', snapshots);
      store.commit('setUserData', data);
      resolve(data);
    }
  } catch (err) {
    // console.error(err);
    reject(err);
  }
});

export const fetchAuthState = () => new Promise((resolve, reject) => {
  onAuthStateChanged(auth, async (res) => {
    if (res?.uid) {
      setUserData(res)
        .then((data: any) => {
          resolve(data);
        })
        .catch((err: Error) => {
          console.error(err);
          // Auth Codes?
          reject(err);
        });
    } else {
      console.log('fetchAuthState: User does not exist');
      const { unsubscribe } = store.state;
      if (typeof unsubscribe !== 'undefined') {
        unsubscribe.forEach((snapshot) => snapshot);
        store.commit('setUnsubscribe', []);
      }
      await store.dispatch('updateCurrentUser', undefined);
      await store.dispatch('updateUserData', undefined);
      store.commit('setUserData', null);

      const error = new Error('User does not exist');
      // this isn't really an error....
      // should we reject or resolve?
      resolve(error);
    }
  });
});

export const loginWithEmailAndPassword = (email: string, password: string) => {
  console.log(email, password);
};

export const signUpUser = (email: string, password: string, firstName: string, lastName: string, companyName: string) => {
  console.log(email, password, firstName, lastName, companyName);
};
